import {Button, Col, Form, InputGroup, Row, Spinner} from 'react-bootstrap'
import {TFormAllValues} from '../../../policies/policiesTypes'
import {useLazyQuery, useQuery} from '@apollo/client'
import {useEffect, useMemo, useState} from 'react'
import {toast} from 'react-toastify'
import {IResPoliciesType} from '../../../../types/policies'
import {GET_ALL_POLICIES_TYPES} from '../../../../gql/queries/policiesQueries'
import {InputCurrency} from 'app/tfi/components/InputCurrency'
import {FormikErrors, FormikTouched} from 'formik'
import {IResCarriersList} from '../../../../types/carriers'
import {useDisclourse} from '../../../../hooks/useDisclourse'
import {IResultPlanJson, IResultsJson, Plan} from '../../../oneLead/oneleadTypes'
import {ModalInfoPlan} from '../../../oneAddQuote/components/ModalInfoPlan'
import {GET_MARKET_PLACE_2} from '../../../../gql/queries/leadsQuery'
import {IResTest} from '../../../../types/leads'
import {normalizeAmount} from '../../../../helpers/consts'
import {IForm} from '../../../oneAddQuote/oneQuoteTypes'
import {mapFormQuoteToQuoteData} from '../../utils-sold'
import {IResStates} from '../../../../types/statesEU'
import { DateInput } from 'app/tfi/components/DateInput'
import {getYearFromEffectiveDate, parseId} from '../../../../helpers'

interface PolicyInsuranceProps {
  onPrevStep: () => void
  onNextStep: () => void
  handleChange: (field: string, value: string) => void
  handleBlur: (field: string) => void
  allValues: TFormAllValues
  errors: FormikErrors<TFormAllValues>
  touched: FormikTouched<TFormAllValues>
  loadingCreate: boolean
  loadingCarriers: boolean
  dataCarriers: IResCarriersList | undefined
  dataStates: IResStates | undefined
  isEdit?: boolean
}

export const PolicyInsuranceTab: React.FC<PolicyInsuranceProps> = ({
  onPrevStep,
  onNextStep,
  handleBlur,
  handleChange,
  allValues,
  errors,
  touched,
  loadingCreate,
  loadingCarriers,
  dataCarriers,
  dataStates,
  isEdit = false,
}) => {
  const [infoPlan, setInfoPlan] = useState<Plan>()
  const {isOpen, onClose, onOpen} = useDisclourse()

  const [gqlGetMarket, {data: dataMarket, loading: loadingPlans, error: errorMarket}] =
    useLazyQuery<IResTest>(GET_MARKET_PLACE_2, {
      fetchPolicy: 'no-cache',
    })

  const handleSearchPlan = () => {
    const vars = mapFormQuoteToQuoteData(allValues, dataStates)
    vars.queryType = 'BUSCAR_PLAN_ID'
    vars.planIds = [allValues.CMSPlanId]

    const {countyfipsName, limit, offset, utilizationLevel, order, ...cleaned} = vars

    const arrPe = [
      {
        ...vars?.personOne,
        age: Number(vars.personOne.age),
        pregnantWith: vars.personOne.pregnantWith ? Number(vars.personOne.pregnantWith) : 0,
        currentEnrollment: vars.personOne.currentEnrollment
          ? {
              ...vars.personOne.currentEnrollment,
              id: undefined,
            }
          : null,
      },
      ...((vars.people ?? []).map((inf) => ({
        ...inf,
        id: undefined,
        age: Number(inf.age),
        pregnantWith: inf.pregnantWith ? Number(inf.pregnantWith) : 0,
        currentEnrollment: inf.currentEnrollment
          ? {
              effectiveDate: inf.currentEnrollment.effectiveDate,
              planId: inf.currentEnrollment.planId,
              useTobacco: inf.currentEnrollment.useTobacco,
            }
          : null,
      })) || []),
    ]

    console.log('handleSearchPlan', {
      ...cleaned,
      householdIncome: Number(cleaned.householdIncome.replaceAll(',', '')),
      personOne: undefined,
      people: arrPe,
    })
    gqlGetMarket({
      variables: {
        ...cleaned,
        year: getYearFromEffectiveDate(cleaned.effectiveDate),
        householdIncome: Number(cleaned.householdIncome.replaceAll(',', '')),
        personOne: undefined,
        people: arrPe,
      },
    })
    onOpen()
  }

  useEffect(() => {
    if (!dataMarket) return

    if (dataMarket.marketplace2) {
      const json = JSON.parse(dataMarket.marketplace2) as IResultPlanJson

      if (json.error) {
        toast.error('Error: Not found Quote')
        return
      }

      if (json.validation_errors) {
        toast.error(`Error: ${json.validation_errors[0].error}`)
        return
      }
      // console.log('json.plans', json)
      setInfoPlan(json.plan)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataMarket])

  const {data, error} = useQuery<IResPoliciesType>(GET_ALL_POLICIES_TYPES, {
    fetchPolicy: 'cache-first',
  })

  useEffect(() => {
    if (error) {
      toast.error(`Error: ${error.message}`)
    }
  }, [error])

  const safeParseId = (value: string) => {
    try {
      return String(parseId(value))
    } catch {
      return value
    }
  }

  const selectedCarrierValue = useMemo(() => {
    if (!dataCarriers || !allValues.carrier) return allValues.carrier

    const current = String(allValues.carrier)
    const exactMatch = dataCarriers.allInsuranceOperatorsList.find(
      (carrier) => String(carrier.id) === current
    )
    if (exactMatch) return exactMatch.id

    const normalizedMatch = dataCarriers.allInsuranceOperatorsList.find(
      (carrier) => safeParseId(String(carrier.id)) === safeParseId(current)
    )
    return normalizedMatch?.id ?? allValues.carrier
  }, [dataCarriers, allValues.carrier])

  return (
    <>
      <div className='policy-insurance-members-container'>
        <div className='kt-heading kt-heading--md custom-border-brand'>
          Policy insurance information
        </div>
        <Row>
          <Row>
            <Col md={4}>
              <Form.Group>
                <Form.Label>
                  Type Policy <small className='text-danger'>(required)</small>
                </Form.Label>
                <Form.Select
                  onChange={(e) => handleChange('typePolicy', '' + e.target.value)}
                  value={allValues.typePolicy}
                  onBlur={() => handleBlur('typePolicy')}
                  isInvalid={Boolean(errors.typePolicy && touched.typePolicy)}
                >
                  <option value=''>Select one</option>
                  {data &&
                    data.allPoliciesType.edges.map(({node}) => (
                      <option key={node.id} value={node.id}>
                        {node.typePolicy}
                      </option>
                    ))}
                </Form.Select>
                {errors.typePolicy && touched.typePolicy && (
                  <></>
                  // <Form.Control.Feedback type='invalid'>{errors.typePolicy}</Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Col md={4}>
            <Form.Group>
              <Form.Label>FFM</Form.Label>
              <Form.Control
                placeholder='FFM used in marketplace'
                onChange={(e) => handleChange('FFM', e.target.value)}
                value={allValues.FFM}
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>NPN</Form.Label>
              <Form.Control
                placeholder='NPN used in marketplace'
                onChange={(e) => handleChange('NPN', e.target.value)}
                value={allValues.NPN}
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Type of Sale</Form.Label>
              <Form.Select
                onChange={(e) => handleChange('typeSale', e.target.value)}
                value={allValues.typeSale}
              >
                <option value=''>Select one</option>
                <option value='New sale'>New sale</option>
                <option value='Renewal'>Renewal</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className='mt-2'>
              <DateInput
                id="effectiveDate"
                name="effectiveDate"
                label="Effective date"
                value={allValues.effectiveDate}
                error={errors.effectiveDate}
                touched={touched.effectiveDate}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Marketplace ID</Form.Label>
              <Form.Control
                placeholder='Marketplace number'
                onChange={(e) => handleChange('marketplaceId', e.target.value)}
                value={allValues.marketplaceId}
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className='mb-3'>
              <Form.Label>Member ID</Form.Label>
              <Form.Control
                value={allValues.memberId}
                onChange={(e) => handleChange('memberId', e.target.value)}
                name='memberId'
                id='memberId'
                placeholder='Insert Member ID'
                required
              />
            </Form.Group>
          </Col>
          <Row>
            <Col md={4}>
              <Form.Group>
                <Form.Label>CMS Plan</Form.Label>
                <InputGroup className='mb-3'>
                  <Form.Control
                    placeholder='CMS Plan id'
                    id='planid'
                    name='planid'
                    value={allValues.CMSPlanId}
                    onChange={(e) => handleChange('CMSPlanId', e.target.value)}
                  />
                  <Button
                    variant='outline-secondary'
                    onClick={handleSearchPlan}
                    className='search-cms-plan'
                    id='button-search-cms-plan'
                  >
                    <i className='bi bi-search' />
                  </Button>
                </InputGroup>
                {/* <Form.Control
                onChange={(e) => handleChange('CMSPlanId', e.target.value)}
                value={allValues.CMSPlanId}
              /> */}
              </Form.Group>
            </Col>
          </Row>

          <Col md={4} className='mb-5'>
            <Form.Group>
              <Form.Label>Carrier</Form.Label>{' '}
              {loadingCarriers && <Spinner animation='border' size='sm' />}
              {dataCarriers ? (
                <Form.Select
                  onChange={(e) => handleChange('carrier', '' + e.target.value)}
                  value={selectedCarrierValue || allValues.carrier}
                  onBlur={() => handleBlur('carrier')}
                >
                  <option value=''>Select one</option>
                  {dataCarriers.allInsuranceOperatorsList.map((carrier) => (
                    <option key={carrier.id} value={carrier.id}>
                      {carrier.name}
                    </option>
                  ))}
                </Form.Select>
              ) : (
                <Form.Control readOnly value={allValues.carrier ?? ''} />
              )}
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Plan Name</Form.Label>
              <Form.Control
                onChange={(e) => handleChange('planName', e.target.value)}
                value={allValues.planName}
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>
                Metal Level <small className='text-danger'>(required)</small>
              </Form.Label>
              <Form.Select
                onChange={(e) => handleChange('metalLevel', e.target.value)}
                value={allValues.metalLevel}
                onBlur={() => handleBlur('metalLevel')}
                isInvalid={Boolean(errors.metalLevel && touched.metalLevel)}
              >
                <option value=''>Select one</option>
                <option value='5'>Platinum</option>
                <option value='4'>Gold</option>
                <option value='3'>Silver</option>
                <option value='2'>Bronze</option>
                <option value='1'>Catastrophic</option>
              </Form.Select>
              {errors.metalLevel && touched.metalLevel && (
                <Form.Control.Feedback type='invalid'>{errors.metalLevel}</Form.Control.Feedback>
              )}
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Policy Total Cost</Form.Label>
              <InputCurrency
                value={normalizeAmount(allValues.policyTotalCost)}
                onValueChange={(v) => handleChange('policyTotalCost', v ?? '')}
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Tax Credit / Subsidy</Form.Label>
              <InputCurrency
                value={normalizeAmount(allValues.taxCredit)}
                onValueChange={(v) => handleChange('taxCredit', v ?? '')}
              />
            </Form.Group>
          </Col>
          <Col className='mb-4'>
            <Form.Group>
              <Form.Label>Monthly Premium</Form.Label>
              <InputCurrency
                value={normalizeAmount(allValues.premium)}
                onValueChange={(v) => handleChange('premium', v ?? '')}
              />
            </Form.Group>
          </Col>
        </Row>
        <div className='btn-prev-next'>
          <Button size='sm' variant='secondary' onClick={onPrevStep}>
            PREVIOUS
          </Button>
          <Button size='sm' onClick={onNextStep}>
            NEXT STEP
          </Button>
        </div>
        {/* AQUI PODRIA SER QUE MANDO EL PLAN ID en vez del INFO PLAN y adentro consulto todo el info delplan */}
        {infoPlan && isOpen && (
          <ModalInfoPlan isOpen={isOpen} onClose={onClose} planInput={infoPlan} isPreview={true} />
        )}
      </div>
    </>
  )
}
